import React from "react";
import { shape, string } from "prop-types";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./fieldIcons.module.scss";
const FieldIcons = props => {
  const {
    after,
    before,
    children
  } = props;
  const classes = mergeClasses(defaultClasses, props.classes);
  const style = {
    "--iconsBefore": before ? 1 : 0,
    "--iconsAfter": after ? 1 : 0
  };
  return /*#__PURE__*/React.createElement("span", {
    className: classes.root,
    style: style
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.input
  }, children), /*#__PURE__*/React.createElement("span", {
    className: classes.before
  }, before), /*#__PURE__*/React.createElement("span", {
    className: classes.after
  }, after));
};
FieldIcons.propTypes = {
  classes: shape({
    after: string,
    before: string,
    root: string
  })
};
export default FieldIcons;